<div *ngIf="loading" class="spinner">
  <mat-spinner></mat-spinner>
</div>
<div [ngClass]="loading ? 'd-none' : ''" class="card card-table">
  <div class="card-body">
    <div style="display:flex; justify-content:space-between;">
      <header class="header">
        <h2 class="card-title">Denúncias da Linha " {{ line_name }} "</h2>
      </header>
      <button style="border: none; background: none; cursor: pointer;" type="button" class="modal-description__close"
        (click)="closeModal()">
        <mat-icon style="margin: 0px; padding: 0px" color="primary">close</mat-icon>
      </button>
    </div>

    <!--Table-->
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSourceDenounces">
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID da Denúncia</th>
          <td style="width: 200px" mat-cell *matCellDef="let element">
            <div (click)="navigateComplaintById(element._id)" style="cursor: pointer">
              {{ element._id.substr(0, 12) }}...
            </div>
          </td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Horário do Ocorrido</th>
          <td style="width: 200px" mat-cell *matCellDef="let element">
            {{ element.datetime | date: "HH:mm" }}
          </td>
        </ng-container>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td style="width: 200px" mat-cell *matCellDef="let element">
            <span class="">
              {{ utilsService.transformType(element.type) }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsDenounces"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsDenounces"></tr>
      </table>
    </div>
    <div class="d-md-flex align-items-center justify-content-end">
      <mat-paginator [pageSizeOptions]="[10, 15, 30]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
